
import { computed, defineComponent, PropType, reactive, watch } from 'vue'
import { AgreementPayload, AgreementType } from '@/modules/agreements/types'
import AgreementFormFieldType from '@/components/agreements/form-fields/type.vue'
import AgreementFormFieldStartDate from '@/components/agreements/form-fields/start-date.vue'
import AgreementFormFieldEndDate from '@/components/agreements/form-fields/end-date.vue'
import AgreementFormFieldInvoicingAllowedFrom from '@/components/agreements/form-fields/invoicing-allowed-from.vue'
import AgreementFormFieldPrice from '@/components/agreements/form-fields/price.vue'
import AgreementFormFieldName from '@/components/agreements/form-fields/name.vue'
import AgreementFormFieldMaxMembersAllowed from '@/components/agreements/form-fields/max-members-allowed.vue'
import AgreementFormFieldMinLength from '@/components/agreements/form-fields/min-length.vue'
import AgreementFormFieldCancelPeriod from '@/components/agreements/form-fields/cancel-period.vue'
import AgreementFormFieldInvoicingPeriod from '@/components/agreements/form-fields/invoicing-period.vue'
import AgreementFormFieldAdditionalInfo from '@/components/agreements/form-fields/additional-info.vue'

export default defineComponent({
    name: 'agreement-basic-info-form',
    components: {
        AgreementFormFieldAdditionalInfo,
        AgreementFormFieldType,
        AgreementFormFieldStartDate,
        AgreementFormFieldEndDate,
        AgreementFormFieldInvoicingAllowedFrom,
        AgreementFormFieldPrice,
        AgreementFormFieldName,
        AgreementFormFieldMaxMembersAllowed,
        AgreementFormFieldMinLength,
        AgreementFormFieldCancelPeriod,
        AgreementFormFieldInvoicingPeriod
    },
    props: {
        modelValue: {
            type: Object as PropType<AgreementPayload>,
            required: true
        }
    },
    emits: ['update:modelValue'],
    setup (props, { emit }) {
        const localModel = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        })

        const rules = reactive({
            requiredRule: (val: string) => !!val || 'Field is required'
        })

        watch(() => localModel.value.type, (newType) => {
            if (newType === AgreementType.Licence) {
                localModel.value.editableInSelfService = false
            }
        })

        const disabledEditInSelfService = computed(() => {
            return props.modelValue.type === AgreementType.Licence
        })
        return {
            localModel,
            rules,
            disabledEditInSelfService
        }
    }
})
